import api from './api';
import type {
  MerchantPickupLocation,
  CreateMerchantPickupLocationInput,
  UpdateMerchantPickupLocationInput,
} from '../types/merchantPickupLocation';

export async function getMerchantPickupLocations(
  includeInactive = false,
  search?: string
): Promise<MerchantPickupLocation[]> {
  const params = new URLSearchParams();
  if (includeInactive) params.append('includeInactive', 'true');
  if (search) params.append('search', search);

  const response = await api.get<{ success: boolean; data: MerchantPickupLocation[] }>(
    `/merchant-pickup-locations?${params.toString()}`
  );
  return response.data.data;
}

export async function getMerchantPickupLocationByMerchantId(
  merchantId: number
): Promise<MerchantPickupLocation | null> {
  try {
    const response = await api.get<{ success: boolean; data: MerchantPickupLocation }>(
      `/merchant-pickup-locations/merchant/${merchantId}`
    );
    return response.data.data;
  } catch {
    return null;
  }
}

export async function createMerchantPickupLocation(
  input: CreateMerchantPickupLocationInput
): Promise<MerchantPickupLocation> {
  const response = await api.post<{ success: boolean; data: MerchantPickupLocation }>(
    '/merchant-pickup-locations',
    input
  );
  return response.data.data;
}

export async function updateMerchantPickupLocation(
  merchantId: number,
  input: UpdateMerchantPickupLocationInput
): Promise<MerchantPickupLocation> {
  const response = await api.put<{ success: boolean; data: MerchantPickupLocation }>(
    `/merchant-pickup-locations/merchant/${merchantId}`,
    input
  );
  return response.data.data;
}

export async function deleteMerchantPickupLocation(
  id: string,
  hard = false
): Promise<void> {
  await api.delete(`/merchant-pickup-locations/${id}${hard ? '?hard=true' : ''}`);
}
